import { ObservableArray, View, ViewModel } from "binder"
import { PricingPerCarModelViewModel } from "./pricingPerCarModel-viewModel"
import { AutomatedPriceUpdatingViewModel } from "../AutomatedPriceUpdating/automatedPriceUpdating-viewModel";

export class PricingPerCarModelView extends View<PricingPerCarModelViewModel>{
    GetViewUniqueId(): string {
        return "V-317CC3B9-B972-4A80-8022-50D9203CF52C"
    }
    loadHtml(): string {
        let element = require('./pricingPerCarModel.html').default;
        let style = require('./pricingPerCarModel.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set pricesPerCarModel(v: ObservableArray<AutomatedPriceUpdatingViewModel>) { this._pricesPerCarModel = v; } public get pricesPerCarModel(): ObservableArray<AutomatedPriceUpdatingViewModel> { return this._pricesPerCarModel;} private _pricesPerCarModel: ObservableArray<AutomatedPriceUpdatingViewModel>;
    public set selectedPricingCarModel(v: AutomatedPriceUpdatingViewModel) { this._selectedPricingCarModel = v; } public get selectedPricingCarModel(): AutomatedPriceUpdatingViewModel { return this._selectedPricingCarModel;} private _selectedPricingCarModel: AutomatedPriceUpdatingViewModel;
    public set popup(v: ViewModel) { this._popup = v; } public get popup(): ViewModel { return this._popup;} private _popup: ViewModel;
    public set shallShowPopup(v: boolean) { this._shallShowPopup = v; } public get shallShowPopup(): boolean { return this._shallShowPopup;} private _shallShowPopup: boolean;
    
}
